import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import { PublicPclProduct } from "api/public/project/product/product.types";

const FullDetailsCell = ({
  row: { product_id, from_cc_portal, status_sort },
}: {
  row: PublicPclProduct;
}) => {
  if (status_sort !== "Certified") {
    return null;
  }

  const domesticLink = `/products/${product_id}`;
  const internationalLink = `/products/international-product/${product_id}`;

  return (
    <Link to={from_cc_portal ? internationalLink : domesticLink}>
      <Button variant="light" size="sm" className="border-dark btn-hover">
        Full Details
      </Button>
    </Link>
  );
};

export default FullDetailsCell;
